/**
 * Take a parameter name and return the value of this parameter.
 * @param { String } parameterName - A parameter name.
 * @return { String }
 */
export const getParamValue = (parameterName) => {
    const urlParams = new URLSearchParams(window.location.search)

    return urlParams.get(parameterName) || ''
}

export const WindowProxy = typeof window !== 'undefined' && window.toString() === '[object Window]' && window
